import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../Box/index.js";
const InputDisclaimer = (t0)=>{
    const $ = c(4);
    const { children, top: t1, left: t2 } = t0;
    const top = void 0 === t1 ? 28 : t1;
    const left = void 0 === t2 ? 20 : t2;
    let t3;
    if ($[0] !== children || $[1] !== left || $[2] !== top) {
        t3 = /*#__PURE__*/ jsx(Box, {
            width: "100%",
            position: "relative",
            children: /*#__PURE__*/ jsx(Box, {
                position: "absolute",
                left: left,
                top: top,
                children: children
            })
        });
        $[0] = children;
        $[1] = left;
        $[2] = top;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
export { InputDisclaimer };
